import { render, staticRenderFns } from "./BundleSharedUpdate.vue?vue&type=template&id=f04b3712"
import script from "./BundleSharedUpdate.vue?vue&type=script&lang=js"
export * from "./BundleSharedUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports